import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';
import { Dayjs } from 'dayjs';
import { PlanUnitMix } from 'components/types';

const addWorkPlaceSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup.object({
    name: yup
      .string()
      .required(t('validationFieldRequired', { name: t('name') })),
    description: yup.string().notRequired(),
    validFrom: yup
      .mixed<Dayjs>()
      .required(t('validationFieldRequired', { name: t('validFrom') }))
      .typeError(t('validationDateInvalid', { name: t('validFrom') })),
    validTo: yup
      .mixed<Dayjs>()
      .required(t('validationFieldRequired', { name: t('validTo') }))
      .typeError(t('validationDateInvalid', { name: t('validTo') }))
      .default(null)
      .test(
        'dayjs-min',
        () =>
          t('validation.greaterThan', {
            field: t('validFrom')
          }),
        (v, ctx) => {
          const validFrom = ctx.parent.validFrom as Dayjs;
          return v && validFrom ? v.isAfter(validFrom) : true;
        }
      ),
    planUnits: yup
      .mixed<PlanUnitMix[]>()
      .required(t('validationFieldRequired', { name: t('planUnit') }))
      .typeError(t('validationFieldRequired', { name: t('planUnit') }))
      .test(
        'min-length',
        () => t('noPlanUnit'),
        (v) => Array.isArray(v) && v.length > 0
      ),
    feature: yup.string().notRequired().nullable(),
    streetName: yup.string().notRequired(),
    houseNumber: yup.string().notRequired(),
    postalCode: yup.string().notRequired(),
    city: yup.string().notRequired(),
    countryCode: yup
      .object()
      .shape({
        value: yup
          .string()
          .required(t('validationFieldRequired', { name: t('country') })),
        label: yup
          .string()
          .required(t('validationFieldRequired', { name: t('country ') }))
      })
      .nullable()
      .notRequired()
  });
};

export default addWorkPlaceSchema;
